import api, { ensureCsrfCookie } from "../axiosConfig";

export const emailDashboardApi = {
  async getDashboard(days = 30) {
    await ensureCsrfCookie();

    // Your email routes in Laravel are under /api/email/...
    const res = await api.get("/email/dashboard", { params: { days } });
    return res.data;
  },

  async getCalendar(params = {}) {
    await ensureCsrfCookie();

    // Backend expects: start=YYYY-MM-DD, end=YYYY-MM-DD, optional only=scheduled|all, tz=IANA name
    const safeParams = {
      start: params.start,
      end: params.end,
      only: params.only ?? "scheduled",
      tz: params.tz ?? "Africa/Harare",
    };

    const res = await api.get("/email/campaigns/calendar", { params: safeParams });
    return res.data; // => { data: [...], meta: {...} }
  },

  async getBlacklistStats() {
    await ensureCsrfCookie();
    const res = await api.get("/blacklist/stats");
    return res.data;
  },

  async updateSchedule(campaignId, payload) {
    await ensureCsrfCookie();

    // Backend expects: { schedule_at: ISO|null, tz?: "Africa/Harare" }
    const safePayload = {
      schedule_at: payload?.schedule_at ?? null,
      tz: payload?.tz ?? "Africa/Harare",
    };

    const res = await api.patch(`/email/campaigns/${campaignId}/schedule`, safePayload);
    return res.data;
  },
};